<template>
  <div
    class="group__info margin-top-10 padding-bottom-10"
    v-if="!isOpenIncomingDocFlow"
  >
    <div class="title font-size__medium">Luồng xử lý</div>
    <transition name="slide" v-if="flowInstances && flowInstances.length">
      <div class="filter flex-row flex__left">
        <div
          v-for="(item, $index) in flowInstances"
          :key="item.id"
          :class="[
              item.isActive ? 'active' : '',
              'item',
              'flex-row',
              'flex__center'
            ]"
          @click="loadLuongXuLyTuChoi(item)"
        >
          <span class="index">#{{ $index + 1 }}</span>
          <span>{{ item.updateTime | convertToLabelFilter }}</span>
        </div>
      </div>
    </transition>
    <div
      class="ctn"
      v-for="item in flowInstances"
      :key="item.id"
      v-show="item.isActive"
    >
      <vbdi-luong-xu-ly
        :flowInstanceId="item.id"
        :docId="id"
        @openVbIncomingFlow="openVbIncomingFlow"
      />
    </div>
    <div v-if="isKyNgoai" class="ctn">
      <vbdi-luongxuly-kyngoai
        :docId="id"
        @openVbIncomingFlow="openVbIncomingFlow"
      />
    </div>
  </div>
  <vbdi-luongxuly
    v-else
    :outgoingDoc="outgoingDoc"
    :incomingFlowDataSelect="incomingFlowDataSelect"
    @closeIncomingDocFlow="closeIncomingDocFlow"
  />
</template>

<script>
  import convertToLabelFilter from "../../filters/convertToLabelFilter";
  import VbdiLuongXuLy from "./components/LuongXuLy";
  import constants from "../../constants";
  import VbdiLuongxulyKyngoai from "./components/vbdi-luongxuly-kyngoai";
  import VbdiLuongxuly from "./components/LuongXuLyV2";
  import outgoingDocService from "../../services/outgoingDocService";
  import vbFlowInstanceService from "../../services/vbFlowInstanceService";

  export default {
    name: "vbdi-luongxuly-wrapper",
    components: {VbdiLuongxuly, VbdiLuongxulyKyngoai, VbdiLuongXuLy},
    filters: {convertToLabelFilter},
    props: ["id"],
    data() {
      return {
        isOpenIncomingDocFlow: false,
        flowInstances: [],
        outgoingDoc: {},
        incomingFlowDataSelect: null
      };
    },
    computed: {
      isKyNgoai() {
        return (
          this.outgoingDoc &&
          this.outgoingDoc.isKyNgoai === constants.OUTGOING_DOC.IS_KY_NGOAI.TRUE
        );
      }
    },
    watch: {
      id() {
        this.loadDocInfo();
      }
    },
    created() {
      if (this.id) this.loadDocInfo();
    },
    methods: {
      loadLuongXuLyTuChoi(item) {
        this.flowInstances.forEach(item => {
          item.isActive = false;
        });
        item.isActive = true;
      },

      openVbIncomingFlow(event) {
        this.incomingFlowDataSelect = event;
        this.isOpenIncomingDocFlow = true;
      },

      closeIncomingDocFlow() {
        this.isOpenIncomingDocFlow = false;
      },

      loadDocInfo() {
        return outgoingDocService
          .findById(this.id)
          .then(response => (this.outgoingDoc = response.data))
          .then(() => this.loadVbFlowInstance());
      },

      loadVbFlowInstance() {
        return vbFlowInstanceService
          .findAll(
            {docId: this.id},
            {page: 0, size: 10, sort: "updateTime,asc"}
          )
          .then(response => {
            this.flowInstances = response.data.map((item, index) => {
              return {
                id: item.id,
                updateTime: item.updateTime,
                isActive: index === (response.data.length - 1)
              };
            });
          });
      },
    }
  };
</script>

<style scoped>
  .filter {
    margin: 24px 0 12px;
  }

  .filter .item {
    cursor: pointer;
    height: 40px;
    padding: 8px;
    position: relative;
    padding-left: 8px;
    background: var(--color-light);
    font-size: 12px;
    transition: var(--transition-regular);
    margin-right: 4px;
    z-index: 5;
  }

  .filter .item:nth-child(2) {
    z-index: 4;
  }

  .filter .item:nth-child(3) {
    z-index: 3;
  }

  .filter .item:nth-child(4) {
    z-index: 2;
  }

  .filter .item:nth-child(5) {
    z-index: 1;
  }

  .filter .item:nth-child(6) {
    z-index: 0;
  }

  .filter .item:nth-child(7) {
    z-index: -1;
  }

  .filter .item:nth-child(8) {
    z-index: -2;
  }

  .filter .item:nth-child(9) {
    z-index: -3;
  }

  .filter .item:after {
    content: "";
    top: 0;
    position: absolute;
    border-bottom: 20px solid transparent;
    border-top: 20px solid transparent;
    height: 0px;
    width: 0px;
    right: -12px;
    border-left: 12px solid var(--color-light);
    z-index: 10;
    transition: var(--transition-regular);
  }

  .filter .item:not(:first-child):before {
    content: "";
    top: 0;
    position: absolute;
    border-bottom: 20px solid transparent;
    border-top: 20px solid transparent;
    height: 0px;
    width: 0px;
    left: 0;
    border-left: 12px solid #fff;
    z-index: 10;
    transition: var(--transition-regular);
  }

  .filter .item.active {
    background-color: var(--color-blue);
    color: white;
    transition: all 0.25s;
    /* z-index: 10; */
  }

  .filter .item.active:after {
    border-left: 12px solid var(--color-blue);
  }

  .filter .item:not(:first-child) {
    padding-left: 20px;
  }

  .filter .item:first-child {
    border-radius: 4px 0 0 4px;
  }

  .filter .item:last-child {
    /*border-radius: 0 4px 4px 0;*/
    padding-right: 16px;
  }

  .filter .item .index {
    display: none;
    width: 24px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin-right: 4px;
    font-size: 12px;
    color: var(--color-dark);
  }

  .filter .item.active .index {
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-out/vbdi-luongxuly-wrapper.vue